import axios from 'axios'
import {  Message } from 'element-ui'
import qs from 'qs'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

const instance = axios.create({
    // 后台接口地址-
    
    baseURL: process.env.VUE_APP_WEB_URL,
    // 响应时间
    timeout: 5000
    
  })

// 请求拦截
instance.interceptors.request.use(config=>{
  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }
  return config
},error=>{
  return Promise.reject(error);
   }
)

// 响应拦截
instance.interceptors.response.use(response=>{
  return response.data
},error=>{
  Message({
    message: error.msg,
    type: 'error',
    duration: 2 * 1000
  })
  return Promise.reject(error)
})

export default instance